import { render, staticRenderFns } from "./ModalPackageItem.vue?vue&type=template&id=792acd78&lang=pug"
import script from "./ModalPackageItem.vue?vue&type=script&lang=js"
export * from "./ModalPackageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports